import { v2 } from '@saucelabs/sl-module-builds';

import { NAMESPACE } from './types';

const reducer = v2.buildsDetail.reducers.createVDCReducer(NAMESPACE);
export default reducer;
